import { View, StyleSheet, Text } from "@react-pdf/renderer";

const border = "1px solid black";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    height: 35,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
    border: border,
  },
  description: {
    width: "35%",
    borderRight: border,
  },
  qty: {
    width: "10%",
    borderRight: border,
  },
  vat: {
    width: "15%",
    borderRight: border,
  },
  price: {
    width: "20%",
    borderRight: border,
  },
  amount: {
    width: "20%",
  },
});

const TableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.description}>Description</Text>
    <Text style={styles.qty}>Quantity</Text>
    <Text style={styles.vat}>VAT</Text>
    <Text style={styles.price}>Unit Price</Text>
    <Text style={styles.amount}>Amount</Text>
  </View>
);

export default TableHeader;
